import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { forLifeOf, LifecycleAware } from '../../../utilities/rxjs.helpers';

@LifecycleAware()
@Component({
    selector: 'lsq-dynamic-form',
    templateUrl: './lsq-dynamic-form.component.html'
})
export class LsqDynamicFormComponent implements OnInit, OnDestroy {
    // Todo: Add fix for updateFeatureFlags
    @Input() public configStream: Observable<any[]>;
    @Input() public dataStream: Observable<any>;
    @Output() public formUpdate = new EventEmitter<any>();
    @Output() public formSubmit = new EventEmitter<any>();
    @Output() public formCancel = new EventEmitter<any>();

    public formGroup: FormGroup;
    public config: any;

    constructor(private formBuilder: FormBuilder) {}

    public ngOnInit() {
        this.configStream.subscribe((x) => {
            if (!x) {
                return;
            }

            this.generateForm(x);
        });

        if (this.dataStream) {
            this.dataStream.pipe(forLifeOf(this)).subscribe((x) => {
                this.formGroup = this.formGroupOf(x);
            });
        }
    }

    public ngOnDestroy(): void {}

    private generateForm(config) {
        this.config = config;
        this.formGroup = this.formGroupOf();

        this.formGroup.valueChanges.subscribe((formValue) => {
            this.formUpdate.emit(formValue);
        });
    }

    private formGroupOf(values?: any): FormGroup {
        const group: any = {};

        this.config.forEach((item) => {
            const value = values ? values[item.name] : item.defaultValue;
            group[item.name] = [value, item.validators || []];
        });

        return this.formBuilder.group(group);
    }

    public handleSubmit(e: Event) {
        e.preventDefault();

        if (!this.formGroup.valid) {
            console.warn('Invalid form.');
            return;
        }

        this.formSubmit.emit(this.formGroup.value);
    }

    public handleCancel(e?: Event) {
        this.formCancel.emit();
    }
}
